/**
 * Custom analytics are limited to the external client portal.
 * Never pass client details, identifiers, tokens, or free-form text.
 * Replit supplies the tracker when analytics is enabled for a published app.
 */
export function trackEvent(name, data) {
  if (typeof window === "undefined") return;
  if (window.location.pathname.replace(/\/+$/, "") !== "/portal") return;

  try {
    const result = window.umami?.track(name, data);
    // Analytics must not interrupt client actions, even if delivery fails.
    result?.catch?.(() => {});
  } catch {
    // The tracker is optional and must never break the portal.
  }
}